
import Footer from "../../layout/footer";
import Header from "../../layout/header";
import "./selectplan.css";

import React, { Fragment } from "react";

function Selectplan() {
  return (
    <Fragment>
      {/* <Header /> */}
      <section className="banner-section1">
        <div className="container">
          <div className="banner-div">
            <div className="row">
              <div className="col-lg-12">
                <div className="banner-txt">
                  <h3>Upsell package</h3>
                  <div className="container">
                    <div className="col-lg-12">
                      <div className="row pos-adj">
                        <div className="col-lg-4">
                          <div className="pri-txt">
                            Do you want unlimited changes in future ?
                          </div>
                          <div className="cddr text-center">
                            <div className="title">
                              <i
                                className="fa fa-paper-plane"
                                aria-hidden="true"
                              ></i>
                              <h2>Basic</h2>
                            </div>
                            <div className="price">
                              <h4>
                                <sup>$</sup>25
                              </h4>
                            </div>
                            <div className="option">
                              <ul>
                                <li>
                                  <i className="fa fa-check" aria-hidden="true"></i>
                                  10 GB Space
                                </li>
                                <li>
                                  <i className="fa fa-check" aria-hidden="true"></i>
                                  3 Domain Names
                                </li>
                                <li>
                                  <i className="fa fa-check" aria-hidden="true"></i>
                                  20 Email Address
                                </li>
                                <li>
                                  <i className="fa fa-check" aria-hidden="true"></i>
                                  Live Support
                                </li>
                              </ul>
                            </div>
                            <a href="#">Get Started</a>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="pri-txt">
                            Do you want us to add or remove services and
                            products in future?
                          </div>
                          <div className="cddr text-center">
                            <div className="title">
                              <i className="fa fa-rocket" aria-hidden="true"></i>
                              <h2>Premium</h2>
                            </div>
                            <div className="price">
                              <h4>
                                <sup>$</sup>100
                              </h4>
                            </div>
                            <div className="option">
                              <ul>
                                <li>
                                  <i className="fa fa-check" aria-hidden="true"></i>
                                  Unlimited GB Space
                                </li>
                                <li>
                                  <i className="fa fa-check" aria-hidden="true"></i>
                                  30 Domain Names
                                </li>
                                <li>
                                  <i className="fa fa-check" aria-hidden="true"></i>
                                  Unlimited Email Address
                                </li>
                                <li>
                                  <i className="fa fa-check" aria-hidden="true"></i>
                                  Live Support
                                </li>
                              </ul>
                            </div>
                            <a href="#">Get Started</a>
                          </div>
                        </div>
                        <div>
                          <button className="btn n-thnks">No Thanks</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <Footer /> */}
    </Fragment>
  );
}
export default Selectplan;
